export default __webpack_public_path__ + "static/media/507451__horroraudio__ghost-kid-sigh-less-verb.da23a79c.mp3";